// Mock data for Fitness Coaching Landing Page

export const mockData = {
  hero: {
    tagline: "Achieve Fat Loss With a Sustainable Process",
    subtitle: "Helping busy adults build muscle & lose fat.",
    ctaText: "Apply Now"
  },
  
  results: {
    title: "Real Results",
    subtitle: "See the progress of clients who committed to the process",
    clientResults: [
      {
        id: 1,
        graphImage: "/images/graph1.jpg",
        testimonial: "So far everything's been great. I feel better and I am getting comments from my family about my weight loss"
      },
      {
        id: 2,
        graphImage: "/images/graph2.jpg",
        testimonial: "Yes I didn't expect to still be able to eat chips and such and lose weight. But the macro plan and guides actually helped a lot with being able to include things like that."
      },
      {
        id: 3,
        graphImage: "/images/graph3.jpg",
        testimonial: "Felt good. Never felt stuffed or that I wasn't eating enough. Perfect amount to feel full and recover the next day"
      }
    ]
  },
  
  vitalMethod: {
    title: "The Vital Method",
    subtitle: "A proven system designed for sustainable transformation",
    pillars: [
      {
        id: 1,
        letter: "V",
        title: "Initial Assessment",
        description: "We learn your habits, goals, and lifestyle to create a plan that works for YOU.",
        icon: "clipboard-check"
      },
      {
        id: 2,
        letter: "I",
        title: "Nutrition Strategy",
        description: "Eat real food in sustainable portions. No crash diets — just results that stick.",
        icon: "utensils"
      },
      {
        id: 3,
        letter: "T",
        title: "Smart Training",
        description: "Workouts programmed for your level and schedule. Every rep drives progress.",
        icon: "dumbbell"
      },
      {
        id: 4,
        letter: "A",
        title: "Mindset & Accountability",
        description: "We help you stay consistent, push past doubt, and show up on hard days.",
        icon: "brain"
      }
    ]
  },
  
  
  about: {
    title: "Meet Your Coach",
    name: "Your Name Here",
    credentials: [
      "Nutrition Specialist",
      "5+ Years Experience"
    ],
    story: "I understand the struggle because I've been there. After years of trying every diet and workout program, I discovered what actually works: a sustainable, personalized approach that fits your life. Now, I help busy adults achieve the body and health they deserve without sacrificing everything they love.",
    image: "/images/coach-photo.jpg"
  },
  
  faqs: [
    {
      id: 1,
      question: "How much time do I need to commit each week?",
      answer: "The program is designed for busy adults. Most clients spend 3-4 hours per week on workouts (3-4 sessions of 45-60 minutes). Meal prep typically takes 2-3 hours on weekends. It's about working smarter, not harder."
    },
    {
      id: 2,
      question: "What if I've tried everything and nothing works?",
      answer: "You're not alone—this is exactly why I created the V.I.T.A.L. method. Most programs fail because they're not sustainable. We focus on building habits you can maintain for life, not quick fixes that lead to rebound weight gain."
    },
    {
      id: 3,
      question: "Do I need a gym membership?",
      answer: "Not necessarily. I can design programs for home workouts with minimal equipment or for full gym access. We'll work with what you have and what fits your lifestyle."
    },
    {
      id: 4,
      question: "How quickly will I see results?",
      answer: "Most clients notice changes in energy and strength within 2-3 weeks. Visible physical changes typically appear within 4-6 weeks. Remember, sustainable fat loss is about 1-2 lbs per week for long-term success."
    },
    {
      id: 5,
      question: "What's included in the coaching program?",
      answer: "You'll receive personal guidance through our coaching app, including custom workout programs, nutrition, and accountability support. We track your progress together and adjust the plan as needed."
    },
    {
      id: 7,
      question: "Will I have to give up foods I love?",
      answer: "Absolutely not. My approach is about learning to eat foods you love in sustainable portions. No elimination diets."
    },
    {
      id: 6,
      question: "Is this program suitable for beginners?",
      answer: "Absolutely! The V.I.T.A.L. method is personalized to your current fitness level. Whether you're just starting out or getting back into fitness, we'll create a plan that challenges you appropriately and scales with your progress."
    }
  ]
};
